export default __webpack_public_path__ + "static/media/blog02.ab0eb367.png";